import { entries, difference } from 'lodash';

export default (requiredPermissions, permissions) => {
    const perms = entries(requiredPermissions);
    return perms.reduce((accum, [key, vals]) => {
        if (
            permissions.hasOwnProperty(key) &&
            difference(vals, permissions[key]).length === 0
        ) {
            return accum && true;
        }
        return false;
    }, true);
};



// WEBPACK FOOTER //
// ./src/helpers/has-required-permissions.js